import * as actions from './actions';
import reducers from './reducer';

export const Nominee = { actions, reducers };
export { NomineeState } from './reducer';
